import React, { useState, useEffect } from 'react';
import './index.css';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { getCategoriasHome } from '../../../services/apiHome';
import { getCidades } from '../../../services/apiCidade';
import { getCondicao } from '../../../services/apiCondicao';
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from "@fortawesome/free-solid-svg-icons";

interface FiltroAnuncioProps {
    isOpen: boolean;
    mostrarFiltro: () => void;
    filtrarCallback: (filtro: any) => void;
    limparFiltros: () => void;
}

const PainelFiltroAnuncio: React.FC<FiltroAnuncioProps> = ({ isOpen, mostrarFiltro, filtrarCallback, limparFiltros }) => {
    const [nomeAnuncio, setNomeAnuncio] = useState('');
    const [categoriaSelecionada, setCategoriaSelecionada] = useState<string>('');
    const [cidadeSelecionada, setCidadeSelecionada] = useState<string>('');
    const [condicaoSelecionada, setCondicaoSelecionada] = useState<string>('');
    const [tipoSelecionado, setTipoSelecionado] = useState<string>('ambos');
    const [valores, setValores] = useState<{ min: number | string, max: number | string }>({ min: '', max: '' });
    const [categorias, setCategorias] = useState<any[]>([]);
    const [cidades, setCidades] = useState<any[]>([]);
    const [condicoes, setCondicoes] = useState<any[]>([]);
    const [botaoFiltrarDesabilitado, setBotaoFiltrarDesabilitado] = useState<boolean>(false);
    const opcoesTipo = [
        { valor: 'ambos', rotulo: "Produtos e Serviços" },
        { valor: 'produtos', rotulo: "Produtos" },
        { valor: 'servicos', rotulo: "Serviços" }
    ];
    const filtrarAnuncios = async () => {
        const filtro: any = {};
        if (nomeAnuncio.trim() !== '') {
            filtro.nmAnuncio = nomeAnuncio.trim();
        }
        if (categoriaSelecionada.trim() !== '') {
            filtro.nmCategoria = categoriaSelecionada.trim();
        }
        if (cidadeSelecionada.trim() !== '') {
            filtro.nmCidade = cidadeSelecionada.trim();
        }
        if (condicaoSelecionada.trim() !== '') {
            filtro.nmCondicao = condicaoSelecionada.trim();
        }
        switch (tipoSelecionado) {
            case 'produtos':
                filtro.dmTipoAnuncio = true;
                break;
            case 'servicos':
                filtro.dmTipoAnuncio = false;
                break;
            case 'ambos':
                delete filtro.dmTipoAnuncio;
                break;
        }

        if (typeof valores.min != 'string' && valores.min > 0) {
            filtro.valorMinimo = valores.min;
        }

        if (typeof valores.max != 'string' && valores.max > 0) {
            filtro.valorMaximo = valores.max;
        }


        Object.keys(filtro).forEach(key => filtro[key] === undefined && delete filtro[key]);
        if (
            nomeAnuncio.trim() === '' &&
            categoriaSelecionada.trim() === '' &&
            cidadeSelecionada.trim() === '' &&
            condicaoSelecionada.trim() === '' &&
            valores.min === 0 &&
            valores.max === 0 &&
            tipoSelecionado === 'ambos'
        ) {
            limparCampos();
        }
        else {
            filtrarCallback(filtro);
        }
        if (isOpen) {
            mostrarFiltro();
        }
    };
    const limparCampos = () => {
        setNomeAnuncio('');
        setCategoriaSelecionada('');
        setCidadeSelecionada('');
        setCondicaoSelecionada('');
        setValores({ min: '', max: '' });
        limparFiltros();
    };

    useEffect(() => {
        const containerAside = document.querySelector('.containerAside') as HTMLElement;
        if (!containerAside) return;
        let lastScrollTop = 0;
        const scrollThreshold = 73;
        const ajustandoScrollPainelAnuncio = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            if (scrollTop > scrollThreshold) {
                if (scrollTop > lastScrollTop) {
                    containerAside.style.top = '0';
                    containerAside.style.marginTop = '10px';
                } else {
                    const marginTop = Math.min(scrollThreshold - (scrollThreshold - scrollTop), scrollThreshold);
                    containerAside.style.marginTop = `${marginTop}px`;
                }
            } else {
                containerAside.style.marginTop = `${scrollThreshold - scrollTop}px`;
            }
            lastScrollTop = scrollTop;
        };
        window.addEventListener('scroll', ajustandoScrollPainelAnuncio);
        return () => {
            window.removeEventListener('scroll', ajustandoScrollPainelAnuncio);
        };
    }, [filtrarAnuncios, limparCampos]);
    useEffect(() => {
        const containerAside = document.querySelector('.containerAside') as HTMLElement;
        if (!containerAside) return;
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        let lastScrollTop = 0;
        const scrollThreshold = 110;
        const ajustandoScrollPainelAnuncioMobile = () => {
            if (mediaQuery.matches) {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                if (scrollTop > scrollThreshold) {
                    if (scrollTop > lastScrollTop) {
                        containerAside.style.marginTop = '10px';
                    } else {
                        const marginTop = Math.min(scrollThreshold - (scrollThreshold - scrollTop), scrollThreshold);
                        containerAside.style.marginTop = `${marginTop}px`;
                    }
                } else {
                    containerAside.style.marginTop = `${scrollThreshold - scrollTop}px`;
                }
                lastScrollTop = scrollTop;
            }
        };
        ajustandoScrollPainelAnuncioMobile();
        window.addEventListener('scroll', ajustandoScrollPainelAnuncioMobile);
        mediaQuery.addEventListener('change', ajustandoScrollPainelAnuncioMobile);
        return () => {
            window.removeEventListener('scroll', ajustandoScrollPainelAnuncioMobile);
            mediaQuery.removeEventListener('change', ajustandoScrollPainelAnuncioMobile);
        };
    }, []);
    useEffect(() => {
        async function fetchCategorias() {
            const categorias = await getCategoriasHome('1');
            const categoriasFiltradas = categorias.filter((categoria: any) => categoria.dmSituacao === true);
            setCategorias(categoriasFiltradas);
        }
        async function fetchCidades() {
            const response = await getCidades('1', '10', 'asc');
            const cidades = await getCidades('1', response.contadorCidades.toString(), 'asc');
            const cidadesFiltradas = cidades.listaCidade.filter((cidade: any) => cidade.dmSituacao === true);
            setCidades(cidadesFiltradas);
        }
        async function fetchCondicoes() {
            const response = await getCondicao('1');
            setCondicoes(response.data);
        }
        fetchCategorias();
        fetchCidades();
        fetchCondicoes();
    }, []);

    useEffect(() => {
        const estaDesativado = typeof valores.min === 'number' && 
        typeof valores.max === 'number' && valores.min > 0 &&
        valores.max > 0 && valores.max < valores.min;
        setBotaoFiltrarDesabilitado(estaDesativado);
    }, [valores])

    const opcaoPadrao = 'Selecione uma opção';
    const lidarComMudancaTexto = (event: React.ChangeEvent<HTMLInputElement>) => {
        const valor = event.target.value;
        setNomeAnuncio(valor);
    };
    const selecaoCategoria = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const valor = event.target.value;
        setCategoriaSelecionada(valor);
    };
    const selecaoCidade = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const valor = event.target.value;
        setCidadeSelecionada(valor);
    };
    const selecaoCondicao = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const valor = event.target.value;
        setCondicaoSelecionada(valor);
    };
    const selecaoTipo = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoSelecionado(event.target.value);
    };
    const lidarComMudancaValorMinimo = (event: React.ChangeEvent<HTMLInputElement>) => {
        const valor = parseInt(event.target.value);
        setValores(prevState => ({ ...prevState, min: valor }));
    };
    const lidarComMudancaValorMaximo = (event: React.ChangeEvent<HTMLInputElement>) => {
        const valor = parseInt(event.target.value);
        setValores(prevState => ({ ...prevState, max: valor }));
    };

    return (
        <div className={`containerAside ${isOpen ? 'aberto' : ''}`}>
            {isOpen && (
                <div className="fecharFiltro" onClick={mostrarFiltro}>
                    <FontAwesomeIcon icon={faXmark} />
                </div>
            )}
            <div className='titulo'>
                <FontAwesomeIcon icon={faFilter} color='#eb9b00' />
                <h1>Filtro</h1>
            </div>
            <div className="conjuntoFormularioFiltro">
                <label className=''>Pesquisar</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Digite aqui..."
                    value={nomeAnuncio}
                    onChange={lidarComMudancaTexto}
                />
            </div>
            <div className="conjuntoFormularioFiltro">
                <label htmlFor="cidadeSelect" className="">Cidade</label>
                <select
                    id="cidadeSelect"
                    className="form-select"
                    value={cidadeSelecionada}
                    onChange={selecaoCidade}
                >
                    <option value="" disabled>{opcaoPadrao}</option>
                    {cidades.map((cidade: any) => (
                        <option
                            key={cidade.cdCidade}
                            value={cidade.nmCidade}
                        >
                            {cidade.nmCidade}
                        </option>
                    ))}
                </select>
            </div>
            <div className="conjuntoFormularioFiltro">
                <label htmlFor="categoriaSelect" className="">Categoria</label>
                <select
                    id="categoriaSelect"
                    className="form-select"
                    value={categoriaSelecionada}
                    onChange={selecaoCategoria}
                >
                    <option value="" disabled>{opcaoPadrao}</option>
                    {categorias.map((categoria: any) => (
                        <option
                            key={categoria.cdCategoria}
                            value={categoria.nmCategoria}
                        >
                            {categoria.nmCategoria}
                        </option>
                    ))}
                </select>
            </div>
            <div className='conjuntoFormularioFiltroTipoCondicao' style={tipoSelecionado === 'produtos'
                ? { gap: '20px', flexDirection: 'row' }
                : {}
            }>
                <div className="conjuntoFormularioFiltro">
                    <label htmlFor="opcoesSelect" className="">Tipo</label>
                    <select
                        id="opcoesSelect"
                        className="form-select"
                        value={tipoSelecionado}
                        onChange={selecaoTipo}
                    >
                        {opcoesTipo.map(opcao => (
                            <option
                                key={opcao.valor}
                                value={opcao.valor}
                            >
                                {opcao.rotulo}
                            </option>
                        ))}
                    </select>
                </div>
                {(tipoSelecionado === 'produtos') && (
                    <div className="conjuntoFormularioFiltro">
                        <label htmlFor="condicaoSelect" className="">Condição</label>
                        <select
                            id="condicaoSelect"
                            className="form-select"
                            value={condicaoSelecionada}
                            onChange={selecaoCondicao}
                        >
                            <option value="" disabled>{opcaoPadrao}</option>
                            {condicoes.map((condicao: any) => (
                                <option
                                    key={condicao.cdCondicao}
                                    value={condicao.nmCondicao}
                                >
                                    {condicao.nmCondicao}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
            <div className="conjuntoFormularioFiltroMinMax">
                <div className="conjuntoFormularioFiltro">
                    <label htmlFor="valorMinimo" className="">Valor Mínimo</label>
                    <input
                        type='number'
                        id="valorMinimo"
                        className="form-control"
                        min={0}
                        value={valores.min}
                        onChange={lidarComMudancaValorMinimo}
                        placeholder='Min'
                    />
                </div>
                <div className="conjuntoFormularioFiltro">
                    <label htmlFor="valorMaximo" className="">Valor Máximo</label>
                    <input
                        type='number'
                        id="valorMaximo"
                        className="form-control"
                        min={valores.min}
                        value={valores.max}
                        onChange={lidarComMudancaValorMaximo}
                        placeholder='Max'
                    />
                </div>
            </div>
            <div className="containerBotoesFiltro">
                <button 
                className='btn btn-outline-warning botoesFiltrarAnuncios' onClick={limparCampos}>Limpar</button>
                <button
                  className={`${botaoFiltrarDesabilitado ? 'classeDesabilitado' : 'btn btn-outline-primary botoesFiltrarAnuncios'}`}
                onClick={filtrarAnuncios} disabled={botaoFiltrarDesabilitado}>Filtrar</button>
            </div>
        </div>
    );
};

export default PainelFiltroAnuncio;
